<template functional>
  <div style="align-content: center">
    <strong> <translate-text keyTranslate="pqr.cut" />:</strong>
    {{ props.row.cutting_week !== null ? props.row.cutting_week : 'NA' }}
    <br />
    <strong> <translate-text keyTranslate="pqr.arrival" />:</strong>
    {{ props.row.arrival_week !== null ? props.row.arrival_week : 'NA' }}
    <br />
  </div>
</template>
<script>
export default {
  name: 'ReceptionWeekFormatter',
};
</script>
